import Webphone from 'common/Webphone'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setNotificationPermissionDenied } from 'store/actions/global'
import { getDevices } from 'store/actions/settings'

export const useBrowserMedia = ({ isUserAuthed }) => {
    const { isMicrophonePermissionDenied, isMultipleTabs } = useSelector((state) => state.global)
    const { calls } = useSelector((state) => state.call)
    const dispatch = useDispatch()

    // Get media devices
    useEffect(() => {
        if (!isUserAuthed || isMultipleTabs || !navigator.mediaDevices) return
        dispatch(getDevices())
        navigator.mediaDevices.ondevicechange = () => dispatch(getDevices())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuthed, isMultipleTabs])
    
    // Check Notification permission
    useEffect(() => {
        if (
            !isUserAuthed ||
            !('Notification' in window) ||
            !('serviceWorker' in navigator) ||
            !('PushManager' in window)
        ) return
        
        let notificationsGranted;
        
        navigator.permissions.query({ name: "notifications" })
            .then((result) => notificationsGranted = result.state === 'granted')
    
        if(notificationsGranted) return;

        Notification.requestPermission().then((result) => {
            dispatch(setNotificationPermissionDenied(result !== 'granted'))
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuthed])
    
    // Finish all calls when microphone permission denied
    useEffect(() => {
        if (isMicrophonePermissionDenied) {
            calls.forEach((call) => call?.number && Webphone.hangup(call.number))
        }
    }, [isMicrophonePermissionDenied, calls])
}
